
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { getLatestPost } from '../blog/blogData';
import OptimizedImage from '../common/OptimizedImage';

const NewsletterSection = () => {
  const latestPost = getLatestPost();
  
  return (
    <section className="bg-[#F7F3EB] py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {/* Latest Blog Post */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <h3 className="text-xl md:text-2xl font-semibold mb-2 px-6 pt-6 text-gray-800">From Our Blog</h3>
              <div className="flex flex-col h-full">
                {latestPost && (
                  <>
                    <div className="overflow-hidden h-48">
                      <OptimizedImage
                        src={latestPost.image}
                        alt={latestPost.title}
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                        width={600}
                        height={300}
                      />
                    </div>
                    <div className="p-6">
                      <h4 className="text-lg font-medium mb-2 text-gray-800">{latestPost.title}</h4>
                      <p className="text-gray-600 mb-4 line-clamp-3">{latestPost.excerpt}</p>
                      <a
                        href={`/blog?post=${latestPost.id}`}
                        className="inline-flex items-center text-primary hover:text-primary-dark transition group"
                      >
                        Read more
                        <ArrowRight className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" />
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>
            
            {/* Newsletter Signup */}
            <div className="bg-[#C46829] text-white rounded-lg shadow-sm overflow-hidden p-6">
              <h3 className="text-xl md:text-2xl font-semibold mb-2">Get cat history in your inbox</h3>
              <p className="mb-6 opacity-90">
                Sign up for our newsletter to receive updates on new tour dates, special events, 
                and fascinating snippets of NYC's feline history.
              </p>
              
              <div id="mc_embed_signup">
                <form
                  action="https://catsabouttowntours.us21.list-manage.com/subscribe/post?u=d61854cb6fb33aef75c51c28c&amp;id=7eb9703685&amp;f_id=00cef5e0f0"
                  method="post"
                  id="mc-embedded-subscribe-form"
                  name="mc-embedded-subscribe-form"
                  className="validate"
                  target="_blank"
                >
                  <div id="mc_embed_signup_scroll">
                    <div className="mc-field-group mb-4">
                      <label htmlFor="mce-EMAIL" className="block mb-2 sr-only">
                        Email Address <span className="asterisk">*</span>
                      </label>
                      <input
                        type="email"
                        name="EMAIL"
                        className="required email w-full px-4 py-3 rounded-md text-gray-800 focus:ring-2 focus:ring-[#F97316] focus:outline-none"
                        id="mce-EMAIL"
                        required
                        placeholder="Your email address"
                      />
                      <span id="mce-EMAIL-HELPERTEXT" className="helper_text"></span>
                    </div>
                    <div id="mce-responses" className="clear foot">
                      <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                      <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
                    </div>
                    <div className="optionalParent">
                      <div className="clear foot">
                        <input
                          type="submit"
                          name="subscribe"
                          id="mc-embedded-subscribe"
                          className="button bg-[#F97316] hover:bg-[#E86305] text-white py-3 px-6 rounded-md cursor-pointer font-medium w-full md:w-auto transition"
                          value="Subscribe"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              
              <p className="text-xs mt-4 opacity-80">
                We respect your privacy and will never share your information. You can unsubscribe at any time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
